import { useState } from 'react';
import context from '.';

/**
 * @param {{
 *  children: JSX.Element,
 * }} props 
 */
const Provider = ({
  children
}) => {
  const [ toasts, setToasts ] = useState([]);

  return (
    <context.Provider value={{toasts, setToasts}}>
      {children}
    </context.Provider>
  )
}

export default Provider;